import clsx from 'clsx'
import React, { FC } from 'react'
import styled from 'styled-components'

import { makeColumns } from '@Components/Header/helpers'
import { CMSPosts } from '@Components/Header/MegaMenu/CMSPosts'
import { Link } from '@Components/Link'
import { NavigationEvent } from '@Events/Navigation'
import { Category } from '@Generated/graphql'
import { sectionInner } from '@Globals/Style/mixins'
import { useTranslation } from '@Globals/Translations'

interface MegaMenuAllCategoriesProps {
  activeID?: number
  categories: Category[]
  menuID: number
}

interface WrapperProps {
  borderColor?: string
  color?: string
  headerSpanTextColor?: string
}

const CategoryItem = ({ id, name, url }: Category) => (
  <Link
    key={id}
    className="categoryItem"
    event={new NavigationEvent({
      attributes: {
        dest_page_type: 'category',
        dest_page_type_id: id,
        source_id: 'mega_menu',
      },
      eventName: 'nav_link_click',
    })}
    href={url || ''}
  >
    {name}
  </Link>
)

const Wrapper = styled.div<WrapperProps>`
  ${sectionInner};
  padding: 15px 35px;
  display: none;
  background-color: ${({ color, theme }) => color ?? theme.colors.white};
  /* TODO: include in theme/colors system as greyLightest darkened 5% */
  border: 1px solid ${({ borderColor }) => borderColor ?? '#e8e8e8'};
  box-shadow: 0 10px 15px 0 rgba(0,0,0,0.05);
  &.isActive {
    display: flex;
    justify-content: space-between;
  }

  .leftSide {
    margin-right: 20px;
  }

  .header {
    margin-bottom: 15px;
    span {
      font-size: 1.5rem;
      color: ${({ headerSpanTextColor, theme }) => headerSpanTextColor ?? theme.colors.greyLight};
    }
  }

  .categoriesWrap {
    display: flex;
  }

  .categoryColumn {
    width: 200px;
  }

  .categoryItem {
    color: ${({ theme }) => theme.colors.greyDark};
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    padding-right: 20px;
    &:hover {
      text-decoration: underline;
    }
  }
`

export const MegaMenuAllCategories: FC<MegaMenuAllCategoriesProps> = ({ activeID, categories, menuID }) => {
  const { t } = useTranslation()
  const columns = makeColumns(categories)

  return (
    <Wrapper
      className={clsx({
        isActive: activeID === menuID,
      })}
    >
      {/* Left side */}
      <div className="leftSide">
        {/* Header */}
        <div className="header">
          <span>{t('header:A_TO_Z_LABEL')}</span>
        </div>

        {/* Categories */}
        <div className="categoriesWrap">
          {columns.map(column => (
            <div key={column.id} className="categoryColumn">
              {column.categories.map(CategoryItem)}
            </div>
          ))}
        </div>
      </div>

      {/* Right side */}
      <CMSPosts />
    </Wrapper>
  )
}
